module.exports = __webpack_public_path__ + "static/media/image-card-5.5f40a7d5.png";